import script from "./exportPDF.vue?vue&type=script&setup=true&lang=js"
export * from "./exportPDF.vue?vue&type=script&setup=true&lang=js"

import "./exportPDF.vue?vue&type=style&index=0&id=fca35f54&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fca35f54"]])

export default __exports__